import $ from "jquery";

export const contestsWorkEditForm = function () {
   $('#contestworkform-submit, #contestworkform-submit-external').click(function () {
        const form = $('#contestworkform');

        if (form.length) {
            form[0].submit();
        }
    })

    $('#isDownloadableDisplay').change(function () {
        const input = $('#contestworkform-isdownloadable');
        const checkbox = $(this);

        input.val(checkbox.prop('checked') ? 1 : 0)
    })

    $('#contest-work-delete-modal .button--red').click(function() {
        $('#contest-work-delete-form').submit();
    })

    $('#isDownloadableDisplay').prop('checked', parseInt($('#contestworkform-isdownloadable').val()))
};
